import React from "react";
import CustomCard from "../../shared/Card/CustomCard";
import UserForm from "./UserForm";

export default function ViewUser({ name }) {
    return (
        <CustomCard title={name}>
            <UserForm type="VIEW" />
        </CustomCard>
    );
}
